import { TableRow } from '@mui/material';
import { styled } from '@mui/system';

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: 'rgba(216, 216, 216, 0.15)',
    },
}));

export default StyledTableRow;